export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_ERROR = "SIGN_IN_ERROR";

export const SIGN_OUT = "SIGN_OUT";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_OUT_ERROR = "SIGN_OUT_ERROR";

export const SIGN_UP = "SIGN_UP";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";

export const SEND_NEW_VERIFICATION = "SEND_NEW_VERIFICATION";
export const SEND_NEW_VERIFICATION_SUCCESS = "SEND_NEW_VERIFICATION_SUCCESS";
export const SEND_NEW_VERIFICATION_ERROR = "SEND_NEW_VERIFICATION_ERROR";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

export const SET_USER = "SET_USER";
export const SET_USER_SUCCESS = "SET_USER_SUCCESS";

export const GET_FAVORITES = "GET_FAVORITES";
export const GET_FAVORITES_SUCCESS = "GET_FAVORITES_SUCCESS";
export const GET_FAVORITES_ERROR = "GET_FAVORITES_ERROR";

export const ADD_FAVORITE = "ADD_FAVORITE";
export const ADD_FAVORITE_SUCCESS = "ADD_FAVORITE_SUCCESS";
export const ADD_FAVORITE_ERROR = "ADD_FAVORITE_ERROR";

export const REMOVE_FAVORITE = "REMOVE_FAVORITE";
export const REMOVE_FAVORITE_SUCCESS = "REMOVE_FAVORITE_SUCCESS";
export const REMOVE_FAVORITE_ERROR = "REMOVE_FAVORITE_ERROR";

export const GET_USER = "GET_USER";
export const GET_USER_ERROR = "GET_USER_ERROR";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";

export const REMOVE_USER = "REMOVE_USER";
export const REMOVE_USER_ERROR = "REMOVE_USER_ERROR";
export const REMOVE_USER_SUCCESS = "REMOVE_USER_SUCCESS";

export const UPDATE_BONUSCARD = "UPDATE_BONUSCARD";
export const UPDATE_BONUSCARD_ERROR = "UPDATE_BONUSCARD_ERROR";
export const UPDATE_BONUSCARD_SUCCESS = "UPDATE_BONUSCARD_SUCCESS";

export const REMOVE_BONUSCARD = "REMOVE_BONUSCARD";
export const REMOVE_BONUSCARD_ERROR = "REMOVE_BONUSCARD_ERROR";
export const REMOVE_BONUSCARD_SUCCESS = "REMOVE_BONUSCARD_SUCCESS";

export const GET_MEMBER_PROMOTIONS = "GET_MEMBER_PROMOTIONS";
export const GET_MEMBER_PROMOTIONS_ERROR = "GET_MEMBER_PROMOTIONS_ERROR";
export const GET_MEMBER_PROMOTIONS_SUCCESS = "GET_MEMBER_PROMOTIONS_SUCCESS";
